<template>
  <div class="container">
    <div class="module-title">
      <span>培训管理 》订单列表</span>
    </div>
    <div class="content">
      <div class="tabs">
        <div class="tabs__item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item.value)" :style="{
          'border-bottom':activeName == item.value ? '1px solid #12618A' : 'none',}">
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="queryBox" v-if="activeName == '1'">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="下单时间：" prop="date">
            <el-date-picker unlink-panels v-model="formatObj.date1" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品类型：">
            <el-select v-model="postForm.product_type" placeholder="请选择产品类型">
              <el-option v-for="item in options1" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号：">
            <el-input v-model="postForm.id" placeholder="请输入订单编号"></el-input>
          </el-form-item>

          <el-form-item class="form-btn">
            <el-button type="primary" size="mini" icon="el-icon-search" @click="search">查询
            </el-button>
            <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="reset">重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 我退款 - 搜索区域 -->
      <div class="queryBox" v-if="activeName == '2'">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="退单时间："  min-width="160">
            <el-date-picker unlink-panels v-model="refundSearchDate.dateRange" type="daterange" range-separator="-" style="width: 260px" 
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品类型：">
            <el-select v-model="refundSearchDate.product_type" placeholder="请选择产品类型"  style="width: 180px">
              <el-option v-for="item in options1" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="refundSearchDate.order_id" placeholder="请输入订单ID"  style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="退单状态：">
            <el-select v-model="refundSearchDate.approval_status" placeholder="请选择退单状态" clearable  style="width: 180px">
              <el-option v-for="item in options10" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" size="mini" icon="el-icon-search" @click="getRefundList">查询</el-button>
            <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="resetRefundSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-list">
        <el-table ref="refTable" v-if="activeName == 1" :data="tableData" border style="padding-left: 0px"
                  :row-class-name="tableRowClassName" :span-method="objectSpanMethod13"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'" v-loading="loading"
                  element-loading-text="数据正在加载中">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="title" label="产品信息" min-width="450">
            <template #default="{ row }">
              <div v-if="row.isSpace"></div>
              <div v-else-if="row.isHeader" class="header-cell">
                <div>
                  <div>
                    <span> 创建时间： </span>
                    <span>
                      {{ row.ctm }}
                    </span>
                  </div>
                  <div @click="oper('0', row)">
                    <span> 订单号： </span>
                    <span>
                      <el-button type="text"> {{ row.id }}</el-button>
                      <i class="el-icon-copy-document"></i>
                    </span>
                  </div>
                </div>
                <div>

                  <el-statistic @finish="timeoutFn" format="HH:mm:ss"
                                :value="new Date(row.wtm).getTime() - new Date(row.ntm).getTime() + Date.now()"
                                time-indices
                                v-if="row.status == 1 && (new Date(row.wtm).getTime()) > new Date(row.ntm).getTime()">
                    <template slot="suffix"> 后自动取消</template>
                  </el-statistic>
                  <!-- <span>
                    {{ row.cancel_time }}

                  </span>
                  <span> 后自动取消 </span> -->
                </div>
              </div>
              <div class="info" v-else>
                <div class="img">
                  <img v-if="row.product_type == 'TS200'" src="@/assets/cr_default_payjob.png" alt=""/>
                  <img v-else :src="imgUrl(row.product_image)" alt=""/>
                </div>
                <div class="des">
                  <div class="title font_weight_700 size14">
                    <span v-for="item in options1" :key="item.dictionary_key">
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'TS200'">{{
                          item.dictionary_value
                        }}-{{
                          row.position_name
                        }}</span>
                      <span
                          v-if="item.dictionary_key == row.product_type && row.product_type == 'AI100'">{{
                          item.dictionary_value
                        }}-{{
                          row.product_name
                        }}</span>
                    </span>
                  </div>
                  <div class="product-info-detail">
                    <div>
                      <span class="label">产品名称：</span>
                      <span>{{ row.product_name || '-' }}</span>
                    </div>
                    <div>
                      <span class="label">产品类型：</span>
                      <span v-for="item in options1" :key="item.dictionary_key">
                        <span v-if="item.dictionary_key == row.product_type">{{ item.dictionary_value }}</span>
                      </span>
                    </div>
                    <div class="validity-period">
                      <span class="label">有效期限：</span>
                      <span class="validity-text">{{ formatDate(row.activation_time) || '未激活' }} ~ {{ formatDate(row.expiration_date) || '未到期' }}</span>
                    </div>
                  </div>
                  <div class="">
                    <span v-if="row.product_type == 'TS200'">{{ row.bidding_enterprise_name }}</span>
                    <div v-else style="display: flex">
                      <span class="begin color7b7b7b">
                        {{ row.package_name || row.package_code || '' }}
                      </span>
                      <div v-for="item in options5" :key="item.dictionary_key">
                        <span v-if="item.dictionary_key == row.activation_type" class="after color7b7b7b">
                          {{ item.dictionary_value }}
                        </span>
                      </div>
                      <span class="span3 color7b7b7b">
                        {{ row.activation_dura || '' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="order_type" label="订单类型" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.order_type,
                    }">订单类型
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>

                  <div>
                    <el-select v-model="searchDate.order_type" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options2" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('order_type')" :disabled="!searchDate.order_type">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('order_type')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options2" :key="item.dictionary_key">
                <span v-if="item.dictionary_key == row.order_type">
                  {{ item.dictionary_value }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="hr_order_user.name" label="购买用户" align="center" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ row.hr_order_user ? row.hr_order_user.name : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="invoice_status" label="发票" align="center" min-width="100">
            <template slot-scope="{ row }">
              <span v-if="row.invoice_status == '1'">未申请</span>
              <span v-else-if="row.invoice_status == '2'">待审核</span>
              <span v-else-if="row.invoice_status == '3'">已开票</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="订单状态" align="center" min-width="150">
            <template #header>
              <div>
                <el-popover placement="bottom" trigger="click" :width="'fit-content'">
                  <template #reference>
                    <span class="header_title pointer" :class="{
                      color_primary: searchDate.status,
                    }">订单状态
                      <i class="iconfont icon-shaixuan2"></i>
                    </span>
                  </template>
                  <div>
                    <el-select v-model="searchDate.status" placeholder="请选择" clearable
                               style="margin: 10px 0; width: 150px">
                      <el-option v-for="item in options3" :key="item.dictionary_key" :label="item.dictionary_value"
                                 :value="item.dictionary_key">
                      </el-option>
                    </el-select>
                    <div class="mt" style="text-align: right">
                      <el-button type="text" @click="searchFilter('status')" :disabled="!searchDate.status">筛选
                      </el-button>
                      <el-button type="text" @click="cancelFilter('status')">重置
                      </el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div v-for="item in options3" :key="item.dictionary_key">
                <p v-if="item.dictionary_key == row.status" class="status">
                  <i class="iconfont icon-kongxinyuanquan size24" :class="[colorClass(item.dictionary_key)]"></i>
                  <span>{{ item.dictionary_value }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_amount" label="订单金额(￥)" align="center" min-width="150"></el-table-column>
          <el-table-column prop="payment_amount" label="实收金额(￥)" align="center" min-width="150"></el-table-column>
          <el-table-column prop="payment_amount" label="分成金额(￥)" align="center" min-width="150">
            <template slot-scope="{ row }">
              <span style="color: red">{{ calcSplitAmount(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center" min-width="160">
            <template slot-scope="{ row }">
              <span>{{ formatDateTime(row.ctime) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activation_time" label="激活时间" align="center" min-width="160">
            <template slot-scope="{ row }">
              <span>{{ formatDateTime(row.activation_time) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="expiration_date" label="到期时间" align="center" min-width="160">
            <template slot-scope="{ row }">
              <span>{{ formatDateTime(row.expiration_date) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300" fixed="right">
            <template v-slot="{ row }">
              <div class="btn_column">
                <el-button @click="oper('2', row)" type="text" size="small">详情</el-button>
                <el-button @click="testRefund(row)" type="text" size="small">退单</el-button>
                <el-button @click="oper('3', row)" type="text" size="small" :disabled="row.status != '1'">取消</el-button>
                <el-button @click="oper('11', row)" type="text" size="small">删除</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <!-- 我退款 - 退单列表 -->
        <div class="refund-list-wrap" v-if="activeName == '2'">
        <el-table :data="refundTableData" border style="padding-left: 0px"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" :height="'100%'" v-loading="refundLoading"
                  element-loading-text="数据正在加载中">
          <el-table-column prop="id" label="退单编号" align="center" min-width="260">
            <template slot-scope="{ row }">
              <span>{{ row.id || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="hr_order.order_number" label="原订单编号" align="center" min-width="200">
            <template slot-scope="{ row }">
              <span>{{ row.order_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refund_amount" label="企业退单金额(￥)" align="center" min-width="160">
            <template slot-scope="{ row }">
              <span style="color: red">{{ row.refund_amount || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="split_refund_amount" label="分成退单金额(￥)" align="center" min-width="160">
            <template slot-scope="{ row }">
              <span style="color: red">{{ calcSplitRefundAmount(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refund_reason" label="退单原因" align="center" min-width="200">
            <template slot-scope="{ row }">
              <span>{{ row.refund_reason || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="approval_status" label="退单状态" align="center" min-width="120">
            <template slot-scope="{ row }">
              <span v-for="item in options10" :key="item.dictionary_key">
                <span v-if="item.dictionary_key == row.approval_status">{{ item.dictionary_value }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="refund_method" label="退款方式" align="center" >
            <template slot-scope="{ row }">
              <span v-for="item in options9" :key="item.dictionary_key">
                <span v-if="item.dictionary_key == row.refund_method">{{ item.dictionary_value }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ctm" label="退单时间" align="center" min-width="250"></el-table-column>
          <el-table-column label="操作" align="center" width="300" fixed="right">
            <template v-slot="{ row }">
              <div class="btn_column">
                <el-button @click="openRefundDetail(row)" type="text" size="small">详情</el-button>
                <el-button @click="openRefundAudit(row)" type="text" size="small" :disabled="row.approval_status != '1'">审核</el-button>
                <el-button @click="cancelRefund(row)" type="text" size="small" :disabled="row.approval_status != '1'">取消退单</el-button>
                <el-button @click="deleteRefund(row)" type="text" size="small" v-if="!(row.approval_status == '1' || row.approval_status == '2')" :disabled="row.approval_status == '1' || row.approval_status == '2'">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>
    </div>
    <div class="cr_footer">
      <div class="footer_left">
        <i class="el-icon-place"></i>
        <div id="box">
          <ul id="con1" :class="{ anim: animate == true }">
            <li v-for="item in items" :key="item.name">{{ item.name }}</li>
          </ul>
        </div>
      </div>
      <div class="footer_right">
          <!-- 我的订单分页 -->
          <el-pagination v-if="activeName == '1'" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="currentPage" :page-sizes="[10, 20, 30]" :page-size="pagesize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
          <!-- 我退款分页 -->
          <el-pagination v-if="activeName == '2'" background @size-change="handleRefundSizeChange" @current-change="handleRefundCurrentChange"
                         :current-page="refundCurrentPage" :page-sizes="[10, 20, 30]" :page-size="refundPagesize"
                         layout="total, sizes, prev, pager, next, jumper" :total="refundTotal">
          </el-pagination>
        </div>
    </div>
    <!--我的订单支付-->
    <el-dialog :visible.sync="dialogVisible" width="350px" :before-close="handleClose" :modal-append-to-body="false">
      <template slot="title">
        <span>
          {{ dialogInfo.title }}
        </span>
        <span class="color_red"> ￥{{ payInfo.payment_amount }} </span>
      </template>
      <div class="qrBox">
        <div v-if="payMethod !='cash'" class="qrcode">
          <qrcode ref="qrcode" :src="qrSrc" :options="{
            width: 200,
            height: 200,
          }"/>
          <div class="overtime" v-if="overtimeShow">
            <p>支付超时关闭</p>
          </div>
        </div>
        <div v-if="payMethod =='cash'"
             style="height: 200px;margin: 20px auto;width: 200px;padding: 50px 0;border: 1px solid #E5E5E5;text-align: center;border-radius: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);">
          <p class="size16 font_weight_700">账户可用额度</p>
          <p class="size16 font_weight_700" style="margin-bottom: 20px">{{ account.available_balance }}元</p>
          <p style="color: red;" v-if="!canPay">余额不足，请更换支付方式</p>
          <el-button style="margin-top: 10px" v-if="payMethod =='cash' " :disabled="!canPay" type="primary" @click="cashPay">
            支付
          </el-button>
          <div class="overtime" v-if="overtimeShow">
            <p>支付超时关闭</p>
          </div>
        </div>
        <div class="tips">
          <span class="size16 padding_5 color_red">
            {{ dialogInfo.tips }}
          </span>
          <div class="time padding_5">
            <span>请在</span>
            <el-statistic ref="statistic" @finish="finish" format="HH:mm:ss" :value="endTime" time-indices>
            </el-statistic>
            <span>完成付款</span>
          </div>
        </div>

        <div class="method">
          <div class="record after pointer" :class="{
            color_primary: payMethod == 'alipay',
          }" @click="changePayMethod('alipay')">
            支付宝
          </div>
          <div class="record after pointer" :class="{
            color_primary: payMethod == 'wechat',
          }" @click="changePayMethod('wechat')">
            微信
          </div>
          <div class="record pointer" :class="{
            color_primary: payMethod == 'cash',
          }" @click="changePayMethod('cash')">
            现金
          </div>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
    </el-dialog>
    <!--我的订单发起退单-->
    <el-dialog v-dialogDrag title="退单确认" :visible.sync="refundDialogVisible" width="550px"
               :modal-append-to-body="false">
      <el-form :model="refundForm" :rules="refundRules" ref="refundFormModel" label-width="100px">
        <el-form-item label="订单编号：">
          <!--          <el-input v-model="refundOrder.id" disabled></el-input>-->
          <span>{{ refundOrder.id }}</span>
        </el-form-item>
        <!--        <el-form-item label="订单试用期限：">-->
        <!--          <el-select v-model="refundOrder.on_trial" style="width:100%" disabled>-->
        <!--            <el-option v-for="item in options7" :key="item.dictionary_key" :label="item.dictionary_value"-->
        <!--                       :value="item.dictionary_key">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="订单退款期限：">-->
        <!--          <el-select v-model="refundOrder.return_deadline" style="width:100%" disabled>-->
        <!--            <el-option v-for="item in options8" :key="item.dictionary_key" :label="item.dictionary_value"-->
        <!--                       :value="item.dictionary_key">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="退款金额：" prop="refund_amount">
          <span>{{ refundForm.refund_amount }}元</span>
        </el-form-item>
        <el-form-item label="退款方式：" prop="refund_method">
          <el-select v-model="refundForm.refund_method" placeholder="请选择退款方式" style="width:100%">
            <el-option v-for="item in options9.filter((item) => item.hide == 1)" :key="item.dictionary_key"
                       :label="item.dictionary_value" :value="item.dictionary_key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退单原因：" prop="refund_reason">
          <el-select v-model="refundForm.refund_reason" placeholder="请选择退单原因" style="width:100%">
            <el-option v-for="item in options6" :key="item.dictionary_value" :label="item.dictionary_value"
                       :value="item.dictionary_value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefund">确 定</el-button>
      </span>
    </el-dialog>
    <!--可续费订单续费下单支付-->
    <el-dialog v-dialogDrag :title="dialogRenewalTitle" :visible.sync="dialogRenewalPay.val"
               :modal-append-to-body="false"
               v-if="dialogRenewalPay.val" center :width="dialogRenewalWidth">
      <!-- v-if  从新渲染 -->
      <pay :dialog="dialogRenewalPay" v-on:parentFn="onRenewalSubmit" v-if="dialogRenewalPay.val"
           :editObj="renewalObj" :original_order="original_order" :is_renewal="true"
           @confirmOrderToPay="changeDialogWidth">
      </pay>
    </el-dialog>

    <!--订单详情-->
    <el-dialog v-dialogDrag title="订单详情" :visible.sync="dialogDetail.val" :modal-append-to-body="false"
               width="800px" custom-class="order-detail-dialog"
               v-if="dialogDetail.val" center>
      <detail :dialog="dialogDetail" v-if="dialogDetail.val" :orderId="detailOrderId" :orderData="detailOrderData" :refundOrder="refundOrderDetail" :type="detailType">
      </detail>
    </el-dialog>

    <!-- 退单审核 -->
    <el-dialog v-dialogDrag title="退单审核" :visible.sync="refundAuditDialogVisible" width="800px"
               :modal-append-to-body="false" @close="closeRefundAudit">
      <el-form :model="refundAuditForm" :rules="refundAuditRules" ref="refundAuditFormModel" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="退单编号：">
              <span>{{ refundAuditRow.id }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原订单编号：">
              <span>{{ refundAuditRow.order_id }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="退单金额：">
              <span style="color: red; font-weight: bold;">{{ refundAuditRow.refund_amount }} 元</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="退还分成金额：">
              <span style="color: red; font-weight: bold;">{{ calcSplitRefundAmount(refundAuditRow) }} 元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="退单原因：">
              <span>{{ refundAuditRow.refund_reason }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核结果：" prop="approval_status">
              <el-radio-group v-model="refundAuditForm.approval_status">
                <el-radio label="2">通过</el-radio>
                <el-radio label="3">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="审核备注：" prop="approval_comment">
              <el-input v-model="refundAuditForm.approval_comment" type="textarea" :rows="3" placeholder="请输入审核备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundAuditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefundAudit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除退单 -->
    <el-dialog v-dialogDrag title="删除退单" :visible.sync="deleteRefundDialogVisible" width="500px"
               :modal-append-to-body="false" @close="closeDeleteRefund" center>
      <div class="delete-refund-content">
        <i class="el-icon-warning-outline"></i>
        <span>确认要删除该退单？删除后不可恢复！</span>
      </div>
      <div class="delete-refund-info" v-if="deleteRefundRow.id">
        <p>退单编号：<span>{{ deleteRefundRow.id }}</span></p>
        <p>原订单编号：<span>{{ deleteRefundRow.order_id }}</span></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDeleteRefund" :disabled="deleteRefundLoading">取 消</el-button>
        <el-button type="primary" :loading="deleteRefundLoading" @click="confirmDeleteRefund">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qrcode from "@/components/common/qrcode.vue";
import pay from '@/components/orderManagement/pay.vue'
import detail from '@/components/orderManagement/detail.vue'
import jwt_decode from "jwt-decode";
import ElementUI from "element-ui";
import router from "@/router/router";

//支付接口 orderWebAlipay
export default {
  components: {
    qrcode, pay, detail
  },
  data() {
    return {
      dialogVisible: false,
      refundDialogVisible: false,
      refundAuditDialogVisible: false,
      refundAuditRow: {},
      refundAuditForm: {
        approval_status: '2',
        approval_comment: ''
      },
      refundAuditRules: {
        approval_status: [{required: true, message: '请选择审核结果', trigger: 'change'}]
      },
      // 删除退单弹窗
      deleteRefundDialogVisible: false,
      deleteRefundRow: {},
      deleteRefundLoading: false,
      timer: null,
      animate: false,
      items: [
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200120）注册数剧等等",
        },
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200122）注册数剧等等",
        },
        {
          name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200123）注册数剧等等",
        },
      ],
      options1: [], //产品类型
      options2: [], //订单类型
      options3: [], //订单状态
      options4: [], //运行状态
      options5: [], //销售类型
      options6: [],//退单原因
      options7: [],//产品试用期限
      options8: [],//产品退款期限
      options9: [],//产品退款方式
      options10: [],//退单审核状态
      options11: [],//订单分成比例 PM-DLFC
      searchDate: {
        order_type: "",
        status: "",
      },
      // tab切换
      tabList: [
        {
          label: "销售订单",
          value: "1",
        },
        {
          label: "销售退单",
          value: "2",
        },
      ],
      //
      tableType: "1",
      activeName: "1",
      // 搜索区域
      formatObj: {
        date1: [],
      },
      postForm: {
        page: 1,
        limit: 10,
        start_time: "",
        end_time: "",
        product_type: "",
        order_number: "",
        order_type: "", // 订单类型
        status: "", // 订单状态
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      // 表格数据
      tableData: [],
      // 二维码
      qrSrc: "",
      //   订单号
      order_number: "",
      maxReconnectAttempts: 5, //最大重连次数
      reconnectAttempts: 0, //当前重连次数
      eventSource: null, //sse
      payMethod: "",
      dialogInfo: {
        title: "支付宝扫码",
        tips: "打开支付宝扫一扫完成支付",
      },
      payInfo: {},
      payTimmer: null,
      endTime: null, //倒计时
      overtimeShow: false, //超时显示


      //  退单
      refundOrder: {},
      refundForm: {},
      refundRules: {
        refund_reason: [{required: true, message: '请选择退单原因', trigger: 'blur'}],
        refund_method: [{required: true, message: '请选择退款方式', trigger: 'blur'}],
      },

      //续费订单
      dialogRenewalPay: {val: false},
      dialogRenewalWidth: '500px',
      dialogRenewalTitle: '',
      original_order: {},
      renewalLoading: false,
      renewalObj: {},

      //订单详情
      dialogDetail: {val: false},
      detailOrderId: '',
      detailOrderData: {},
      refundOrderDetail: {},
      detailWidth: '550px',
      detailType: '',

      account: {},//账户信息
      canPay: false,//余额能否支付

      // 退单相关
      refundTableData: [],
      refundLoading: false,
      refundTotal: 0,
      refundCurrentPage: 1,
      refundPagesize: 10,
      refundSearchDate: {
        dateRange: [],
        product_type: '',
        order_id: '',
        approval_status: '',
      },

    };
  },
  mounted() {
    this.timer = setInterval(this.scroll, 2000);
    this.getList();
    this.options1 = this.getDictsData("PM-COMPANY-CPLX", "options1", ["视频课程", "线下课程"]);
    this.options2 = this.getDictsData("PM-COMPANY-DDLX", "options2");
    this.options3 = this.getDictsData("PM-COMPANY-DDZT", "options3");
    this.options4 = this.getDictsData("PM-COMPANY-YXZT", "options4");
    this.options5 = this.getDictsData("PM-COMPANY-XSLX", "options5");
    this.options6 = this.getDictsData("TDGL-TDYY", "options6");
    this.options10 = this.getDictsData("TDGL-SPZT", "options10");
    this.options11 = this.getDictsData("PM-DLFC", "options11");
    if (this.$route.query.tab) {
      if (this.$route.query.status) {
        this.searchDate.status = '1'
        this.postForm.status = '1'
      }
      this.changeTab(this.$route.query.tab)
    }
    this.getData()
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.payTimmer);
    this.payTimmer = null;
    this.eventSource && this.eventSource.close();
    this.eventSource = null;
  },
  computed: {
    imgUrl() {
      return function (url) {
        return `/api/common/files${url}`;
      };
    },
    colorClass() {
      return function (key) {
        switch (key) {
          case "1":
          case "2":
            return "color_red";
            break;
          case "3":
          case "4":
            return "color_green";
            break;
          case "5":
          case "6":
            return "color_yellow";
            break;
          default:
            break;
        }
        // return url ? 'dot' : ''
      };
    },
    fontColorClass() {
      return function (key) {
        switch (key) {
          case "1":
            return "icon-yunhang1 color_green";
          case "2":
            return "icon-stop-circle color_gray";
            break;
          default:
            break;
        }
      };
    },
  },

  methods: {
    //获取当前用户账户
    getData() {
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.accountFundsGet, {
                data: {
                  // enterprise_id: localStorage.getItem("enterprise_id")
                  user_id: JSON.parse(localStorage.getItem('useritem')).id,
                }
              }).then((res) => {
        if (res.data.code == 0) {
          this.account = res.data.data
        } else {
          this.$message({type: "error", message: res.data.msg});
        }

      }).catch((err) => {
        this.loading = false;
      });
    },
    searchFilter(property) {
      this.postForm[property] = this.searchDate[property];
      this.getList();
    },
    cancelFilter(property) {
      this.searchDate[property] = "";
      this.postForm[property] = this.searchDate[property];
      this.getList();
    },
    // 获取数据字典值
    async getDictsData(dict, optionsNmae, filterValues) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail || [];
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      if (filterValues && Array.isArray(filterValues) && filterValues.length) {
        options = options.filter(
          (item) => filterValues.indexOf(item.dictionary_value) > -1
        );
      }
      this[optionsNmae] = options;
    },
    scroll() {
      let con = document.getElementById("con1");
      con.style.marginTop = "-34px";
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.items.push(that.items[0]);
        that.items.shift();
        con.style.marginTop = "0px";
        that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
        this.timer = null;
      }, 1000);
    },
    formatDate(date) {
      if (!date) return '';
      // Handle "0001-01-01T00:00:00Z" or similar invalid dates
      if (date.startsWith('0001-01-01')) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 计算分成金额
    calcSplitAmount(row) {
      if (!row || !row.product_type) return 0;
      const payment = parseFloat(row.payment_amount) || 0;
      const rate = this.options11.find(item => item.dictionary_key === row.product_type);
      if (!rate) return 0;
      const ratio = parseFloat(rate.dictionary_value) || 0;
      return (payment * ratio).toFixed(3);
    },
    // 计算分成退单金额（退单金额 * 字典值）
    calcSplitRefundAmount(row) {
      if (!row) return 0;
      const refund = parseFloat(row.refund_amount) || 0;
      // 退单的产品类型可能在 hr_order 嵌套对象中
      const productType = row.product_type || (row.hr_order && row.hr_order.product_type);
      if (!productType) return 0;
      const rate = this.options11.find(item => item.dictionary_key === productType);
      if (!rate) return 0;
      const ratio = parseFloat(rate.dictionary_value) || 0;
      return (refund * ratio).toFixed(3);
    },
    formatDateTime(date) {
      if (!date) return '';
      if (date.startsWith('0001-01-01')) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      const second = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    changeTab(value) {
      this.activeName = value;
      if (value == '2') {
        this.getRefundList(1);
        this.setRefundForm();
      } else {
        this.getList();
      }
    },
    getList() {
      this.tableData = []
      this.loading = true;
      this.postForm.page = this.currentPage;
      this.postForm.limit = this.pagesize;
      let user = JSON.parse(localStorage.getItem('useritem'))
      let formaterFileds = {
        start_time: (this.formatObj.date1 && this.formatObj.date1.length) ? this.formatObj.date1[0] : "",
        end_time: (this.formatObj.date1 && this.formatObj.date1.length) ? this.formatObj.date1[1] : "",
        product_type2: ["CN400", "CT300"],
      };
      let url = "";
      switch (this.activeName) {
        case "1":
          url = this.$baseUrl.orderList;
          formaterFileds.order_role = '1'
          break;
        case "2":
          url = this.$baseUrl.refundList;
          formaterFileds.order_role = '1'
          formaterFileds.approval_status = '1'
          this.getDictsData("TDGL-SPZT", "options10");
          break;
        case "3":
          url = this.$baseUrl.refundList;
          this.getDictsData("TDGL-SPZT", "options10");
          formaterFileds.order_id = this.postForm.id
          break;
        default:
          break;
      }

      this.$tools
          .asyncPost(this, url, {
            data: Object.assign({}, this.postForm, formaterFileds),
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.tableData = res.data.data.data;
              this.tableData = this.tableData.flatMap((item) => [
                {isSpace: true, id: `space_${item.id}`},
                {isHeader: true, id: `header_${item.id}`, ...item}, // 标题行
                {...item, isHeader: false}, // 数据行
              ]);
              if (this.activeName == '2') {
                this.tableData.forEach(async item => {
                  item.renewalFlag = await this.checkExpirationReminder(new Date(item.expiration_date_str), new Date(item.ntm), item.activation_dura?.slice(0, -2))
                })
              }
              this.total = res.data.data.total;
              this.$nextTick(() => {
                this.$refs.refTable.doLayout(); //重新渲染表格
              });
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
    },
    handleSizeChange(val) {
      this.pagesize = val; //每页下拉显示数据
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val; //点击第几页
      this.getList();
    },
    search() {
      // console.log(value);
      // this.postForm1.enterprise_id = value
      this.currentPage = 1;

      this.getList();
    },
    // 重置
    reset() {
      let obj = {
        start_time: "",
        end_time: "",
        product_type: "",
        order_number: "",
        id: ''
      };
      Object.keys(obj).forEach((key) => {
        this.postForm[key] = obj[key];
      });
      this.formatObj.date1 = [];

      this.currentPage = 1;
      // this.pagesize = 10;
      this.getList();
    },
    // 表格-合并行1、3
    objectSpanMethod13({row, columnIndex}) {
      if (row.isSpace) {
        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 12}
            break;
          default:
            return {rowspan: 0, colspan: 0};
            break;
        }
      }
      if (row.isHeader) {
        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 12}
            break;
          default:
            return {rowspan: 0, colspan: 0};
            break;
        }
      }
      return {rowspan: 1, colspan: 1};
    },
    objectSpanMethod2({row, columnIndex}) {
      if (row.isSpace) {


        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 5}
            break;
            // case 4:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;

        }
      }
      if (row.isHeader) {

        switch (columnIndex) {
          case 0:
            return {rowspan: 1, colspan: 5}
            break;
            // case 4:
            //   return { rowspan: 1, colspan: 1 }
          default:
            return {rowspan: 0, colspan: 0}; // 其他列隐藏
            break;
        }
        // return columnIndex === 0
        //   ? { rowspan: 1, colspan: this.activeName=='2'?4 :5  } // 首列合并所有列
        //   : { rowspan: 0, colspan: 0 }; // 其他列隐藏
      }
      return {rowspan: 1, colspan: 1}; // 数据行正常显示
    },
    // 行类名，用来修改颜色
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 3 == 0) {
        return "space-row";
      } else if (rowIndex % 3 == 1) {
        return "header-row";
      }
      return "";
    },
    async oper(type, row) {
      switch (type) {
        case "0": //复制订单
          const el = document.createElement("input");
          el.value = row.id;
          el.style.position = "fixed"; // 避免页面滚动
          document.body.appendChild(el);
          el.select();
          const success = document.execCommand("copy");
          try {
            if (success) {
              this.$message({
                showClose: true,
                message: "复制成功",
                type: "success",
              });
            } else {
              console.error("复制失败");
            }
          } catch (error) {
            console.error("复制失败:", err);
          } finally {
            document.body.removeChild(el);
          }

          // navigator.clipboard.writeText(row.order_number)
          //     .then(() => this.$message({
          //         showClose: true,
          //         message: '复制成功',
          //         type: 'success'
          //     }))
          //     .catch(err => console.error("复制失败：", err));
          break;
        case "1": //我的订单支付
          this.payInfo = {};
          this.payInfo = row;
          this.payMethod = '';
          this.changePayMethod('alipay');

          // this.$MessageBox.confirm('确定要删除吗?', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          // }).then(() => {
          //     this.$tools
          //         .asyncPost(
          //             this,
          //             this.$baseUrl.applyforDel, {
          //             data: {
          //                 ids: [row.id]
          //             }
          //         }).then((res) => {
          //             if (res.data.code == 0) {
          //                 this.$message({
          //                     type: "success",
          //                     message: "删除成功!",
          //                 });
          //                 this.onSubmit();
          //             } else {
          //                 this.$message({ type: "error", message: res.data.msg });
          //             }

          //         }).catch((err) => { });
          // })
          break;
        case "2": //我的订单订单详情
          this.dialogDetail.val = true
          this.detailOrderId = row.id
          this.detailOrderData = row
          this.refundOrderDetail = {}
          this.detailType = ''
          this.detailWidth = '550px'
          break;
        case "7":
        case "9":
          this.dialogDetail.val = true
          this.detailOrderId = row.id
          this.detailOrderData = row
          this.refundOrderDetail = row
          this.detailType = 'refund'
          this.detailWidth = '800px'
          break;
        case "3": //我的订单取消订单
          this.$MessageBox
              .confirm("确定要取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.orderCancel, {
                      data: {
                        id: row.id,
                        order_role: JSON.parse(localStorage.getItem('useritem')).acctype
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "取消成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        case "4": //我的订单退单
          this.checkTD(row)
          break;
        case "5": //续费订单续费
          this.toRenewal(row)
          break;
        case "6": //续费订单升级
          break;
        case "8": //退单删除订单--已拒绝
          this.$MessageBox
              .confirm("确定要删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.refundDel, {
                      data: {
                        ids: [row.id],
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "删除成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        case "10": //退单取消订单--待退单
          this.$MessageBox
              .confirm("确定要取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.refundCancel, {
                      data: {
                        id: row.id,
                        order_id: row.order_id,
                        approval_comment: ""
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "取消成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        case '11':
          this.$MessageBox
              .confirm("确定要删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                this.$tools
                    .asyncPost(this, this.$baseUrl.orderDel, {
                      data: {
                        ids: [row.id],
                        order_role: JSON.parse(localStorage.getItem('useritem')).acctype
                      },
                    })
                    .then((res) => {
                      if (res.data.code == 0) {
                        this.$message({
                          type: "success",
                          message: "删除成功!",
                        });
                        this.getList();
                      } else {
                        this.$message({type: "error", message: res.data.msg});
                      }
                    })
                    .catch((err) => {
                    });
              });
          break;
        default:
          break;
      }
    },

    //退单
    //检测订单时候可退单
    checkTD(order) {
      this.$tools
          .asyncPost(this, this.$baseUrl.orderGet, {
            data: {
              id: order.id,
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            }
          }).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.return_status) {
            this.setRefundForm(order)
          } else {
            this.$message({
              type: "error",
              message: "不可退单!",
            });
          }
        }
      })
    },
    //计算月单价
    calculateMonthlyPrice(totalAmount, activationDuration) {
      // 提取月份数字
      const months = parseInt(activationDuration.replace('个月', ''));
      // 将总价转换为分（整数）
      const totalCents = Math.round(parseFloat(totalAmount) * 100);
      // 计算月单价（分）
      const monthlyCents = Math.round(totalCents / months);
      // 转换回元，保留2位小数
      const monthlyPrice = (monthlyCents / 100).toFixed(2);
      return monthlyPrice;
    },

    /**
     * 计算退款金额（退款期限从试用期结束后开始计算）
     * @param {number} totalAmount - 订单总金额
     * @param {number} monthlyDeduction - 产品单价（月为单位）
     * @param {Date} purchaseDate - 购买日期
     * @param {Date} currentDate - 当前日期（申请退款日期）
     * @param {string} trialPeriod - 试用期（"7天" | "15天" | "1个月" | "3个月"）
     * @returns {number} 应退款金额
     */
    calculateRefund(totalAmount, monthlyDeduction, purchaseDate, currentDate, trialPeriod) {
      // 将金额转换为分（整数）进行计算
      const totalAmountCents = Math.round(parseFloat(totalAmount) * 100);
      const monthlyDeductionCents = Math.round(parseFloat(monthlyDeduction) * 100);

      // 计算试用期结束日期
      const trialEndDate = new Date(purchaseDate);
      if (trialPeriod.endsWith('天')) {
        trialEndDate.setDate(trialEndDate.getDate() + parseInt(trialPeriod.slice(0, -1)));
      } else if (trialPeriod.endsWith('月')) {
        trialEndDate.setMonth(trialEndDate.getMonth() + parseInt(trialPeriod.slice(0, -1)));
      } else {
        throw new Error("试用期参数错误");
      }

      // 当前日期如果在试用期内 → 全额退款
      if (currentDate <= trialEndDate) {
        return totalAmount;
      }

      // 试用期结束后，计算已过天数
      const daysAfterTrial = Math.floor((currentDate - trialEndDate) / (1000 * 60 * 60 * 24));

      // 按使用月份扣费（不足1个月算1个月）
      const usedMonths = Math.ceil(daysAfterTrial / 30);
      const deductionCents = Math.min(usedMonths * monthlyDeductionCents, totalAmountCents);

      // 计算退款金额（分），然后转换回元
      const refundCents = Math.max(0, totalAmountCents - deductionCents);
      const refundAmount = (refundCents / 100).toFixed(2);

      return refundAmount;
    },
    //初始化退款表单
    async setRefundForm(order) {
      this.refundForm = {}
      this.refundOrder = {}
      await this.getDictsData("PM-CORERIVER-SYQX", "options7");
      await this.getDictsData("PM-CORERIVER-THQX", "options8");
      await this.getDictsData("TDGL-TDFS", "options9");
      // 如果没有传order，仅预加载字典
      if (!order) return
      this.refundOrder = order

      //获取试用期限
      let trialPeriod = ''
      this.options7.forEach(item => {
        if (item.dictionary_key == order.on_trial) {
          trialPeriod = item.dictionary_value.slice(0, -3)
        }
      })
      this.refundForm.refund_amount = this.calculateRefund(order.payment_amount, this.calculateMonthlyPrice(order.total_amount, order.activation_dura), new Date(order.ctm), new Date(), trialPeriod)
      // this.refundForm.refund_amount = this.calculateRefund1('0.24',this.calculateMonthlyPrice('0.24','24个月'), new Date('2025-9-02'), new Date(), trialPeriod)
      this.refundDialogVisible = true
    },
    submitRefund() {
      this.$refs["refundFormModel"].validate((valid) => {
        if (valid) {
          let tmpform = {
            refund_reason: this.refundForm.refund_reason,
            refund_amount: this.refundForm.refund_amount,
            order_id: this.refundOrder.id,
            user_id: this.refundOrder.user_id,
            refund_method: this.refundForm.refund_method,
            product_type: this.refundOrder.product_type,
            order_number: this.refundOrder.order_number,
            order_role: JSON.parse(localStorage.getItem('useritem')).acctype,
            approval_comment: '',
            e_user_id: this.refundOrder.e_user_id || '',
            split_amount: this.calcSplitRefundAmount({
              refund_amount: this.refundForm.refund_amount,
              product_type: this.refundOrder.product_type
            })
          }
          this.$tools
              .asyncPost(this, this.$baseUrl.refundAdd, {
                data: tmpform
              }).then(res => {
            if (res.data.code == 0) {
              this.refundDialogVisible = false
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.getList()
            }
          })
        }
      })
    },

    detail(row) {
      console.log(row);
      // this.$router.push({
      //     path: "/index/accessDetail",
      //     query: {
      //         id: row.id,
      //         type: 'access'
      //     }
      // });
    },

    //我的订单支付
    handleClose(done) {
      clearInterval(this.payTimmer);
      this.payTimmer = null;
      console.log('handleClose', this.eventSource)
      // 确保SSE连接完全关闭
      if (this.eventSource) {
        console.log('准备关闭sse连接')
        this.eventSource.close();
        console.log('已经关闭sse连接')
        this.eventSource = null;
      }
      this.overtimeShow = false;
      this.payMethod = "";
      this.qrSrc = "";
      this.order_number = "";
      this.dialogVisible = false;
    },
    timerFn() {
      this.endTime--;
      console.log(this.endTime, 'endTime');
    },
    connectSSE() {
      console.log('开始连接之前eventSource', this.eventSource)
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      this.eventSource = new EventSource(
          this.$baseUrl.getWebPayStatusSse + `?order_no=${this.order_number}` + '&order_role=' + JSON.parse(localStorage.getItem('useritem')).acctype
      );

      console.log('sse链接对象', this.eventSource)

      this.eventSource.onopen = () => {
        console.log("SSE连接已建立");
        this.reconnectAttempts = 0; // 重置重连计数器
      };

      this.eventSource.onmessage = (e) => {
        console.log("收到消息:", e.data);
        // 处理消息逻辑
      };
      this.eventSource.addEventListener("ok", (e) => {
        console.log("收到消息:", e.data);
        if (
            e.data.indexOf("SUCCESS") !== -1 &&
            e.data.indexOf(this.order_number) !== -1
        ) {
          this.paySuccess();
        }
      });
      this.eventSource.onerror = () => {
        console.log('连接关闭', this.eventSource)
        if (this.eventSource.readyState === EventSource.CLOSED) {
          console.log("连接已关闭");
        }

        // 渐进式重连
        const delay = Math.min(
            1000 * Math.pow(2, this.reconnectAttempts),
            30000
        );
        this.reconnectAttempts++;

        if (this.reconnectAttempts <= this.maxReconnectAttempts) {
          console.log(
              `尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`
          );
          setTimeout(() => this.connectSSE(), delay);
        } else {
          console.error("达到最大重连次数");
        }
      };
    },
    // 支付成功
    paySuccess() {
      this.$message({
        type: "success",
        message: "支付成功!",
      });
      this.handleClose()
      this.getList();
    },
    finish() {
      clearInterval(this.payTimmer);
      this.payTimmer = null;
      this.overtimeShow = true;
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    },
    timeoutFn() {
      this.getList();
    },
    changePayMethod(method) {
      console.log(55555, method, this.payInfo)
      // 如果点击的方式没变化并且没有超时，则不进行任何操作
      if (this.payMethod == method && !this.overtimeShow) {
        return;
      }
      // 完全重置支付状态
      this.resetPaymentState();

      this.payMethod = method;
      if (this.$refs.statistic) {
        this.$refs.statistic.suspend(true); // 暂停定时器
      }

      switch (method) {
        case "alipay":
          this.dialogInfo.title = "支付宝扫码";
          this.dialogInfo.tips = "打开支付宝扫一扫完成支付";
          break;
        case "wechat":
          this.dialogInfo.title = "微信扫码";
          this.dialogInfo.tips = "打开微信扫一扫完成支付";
          break;
        case "cash":
          this.dialogInfo.title = "余额支付";
          this.dialogInfo.tips = "使用账户余额完成支付";
          if (this.payInfo.payment_amount > this.account.available_balance) {
            this.canPay = false
          } else {
            this.canPay = true
          }
        default:
          break;
      }
      if (method == 'cash') {
        this.$refs.statistic.suspend(false); // 开始倒计时
        return
      }
      let result = this.testToken()
      if (!result) {
        return
      }
      this.$tools
          .asyncPost(this, this.$baseUrl.orderWebAlipay, {
            data: {
              id: this.payInfo.id,
              user_id: this.payInfo.user_id,
              product_code: this.payInfo.product_code,
              product_name: this.payInfo.product_name,
              package_code: this.payInfo.package_code,
              provider: this.payMethod,
                method: "scan",
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              let info = res.data.data;
              this.qrSrc = info.pay_url;
              this.order_number = info.order_number;
              // 轮询：系统到期时间-系统当前时间+ 当前时间
              this.endTime =
                  new Date(info.wtm).getTime() - new Date(info.ntm).getTime() + Date.now();
              // console.log('倒计时结束时间',this.endTime)
              this.dialogVisible = true;
              this.$nextTick(() => {
                this.$refs.qrcode.init();
                this.overtimeShow = false;
                this.$refs.statistic.suspend(false); // 开始倒计时
                this.payTimmer = setInterval(this.timerFn, 1000);
                // console.log('倒计时', this.payTimmer)
                console.log('开始监听支付')
                if (this.eventSource) {
                  console.log('如果之前有监听，则需要关闭后开启新监听')
                  this.eventSource.close();
                  this.eventSource = null;
                }
                this.connectSSE();
              });
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          })
          .catch((err) => {
          });
    },
    //现金支付
    cashPay(){
      this.$tools
          .asyncPost(this, this.$baseUrl.orderWebAlipay, {
            data: {
              id: this.payInfo.id,
              user_id: this.payInfo.user_id,
              product_code: this.payInfo.product_code,
              product_name: this.payInfo.product_name,
              package_code: this.payInfo.package_code,
              provider: this.payMethod,
                method: "scan",
              order_role: JSON.parse(localStorage.getItem('useritem')).acctype
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              let info = res.data.data;
              this.order_number = info.order_number;
              // 轮询：系统到期时间-系统当前时间+ 当前时间
              this.endTime =
                  new Date(info.wtm).getTime() - new Date(info.ntm).getTime() + Date.now();
              // console.log('倒计时结束时间',this.endTime)
              this.dialogVisible = true;
              this.$nextTick(() => {
                this.overtimeShow = false;
                this.$refs.statistic.suspend(false); // 开始倒计时
                this.payTimmer = setInterval(this.timerFn, 1000);
                //TODO 获取支付结果
                this.paySuccess();

              });
            } else {
              this.$message({type: "error", message: res.data.msg});
            }
          })
          .catch((err) => {
          });
    },
    // 重置支付状态
    resetPaymentState() {
      clearInterval(this.payTimmer);
      this.payTimmer = null;

      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      if (this.$refs.statistic) {
        this.$refs.statistic.suspend(true);
      }

      this.qrSrc = "";
      this.order_number = "";
      this.overtimeShow = false;
    },

    //续费订单
    //  判断当前订单是否可以续费
    /**
     * 检查当前时间是否在订单到期前的特定时间内
     * @param {Date} expireTime 订单到期时间
     * @param {Date} currentTime 当前时间
     * @param {number} validityPeriod 有效期（以月为单位）
     * @returns {boolean} 是否在提醒时间内
     */
    checkExpirationReminder(expireTime, currentTime, validityPeriod) {
      // 计算剩余时间（毫秒）
      const remainingTime = expireTime.getTime() - currentTime.getTime();

      // 将剩余时间转换为天数
      const remainingDays = remainingTime / (1000 * 60 * 60 * 24);

      if (validityPeriod <= 1) {
        // 有效期为1个月或更短时，15天内返回true
        return remainingDays <= 15 && remainingDays >= 0;
      } else {
        // 有效期大于1个月时，30天内返回true
        return remainingDays <= 30 && remainingDays >= 0;
      }
    },
    //续费下单
    async toRenewal(row) {
      this.renewalLoading = true
      this.dialogRenewalWidth = '500px'

      this.original_order = {
        original_order_id: row.id,
        original_order_number: row.order_number
      }
      //组装续费订单产品及套餐信息
      let {pro, pack} = await this.getRenewalProDetail(row.product_id, row.package_code)
      if (Object.keys(pack).length == 0) {
        this.$message({type: "error", message: '当前套餐已下架，请选择其他产品进行购买！'});
        this.renewalLoading = false
        return
      }
      this.renewalObj = {
        pro: pro,
        pack: pack,
      };

      this.dialogRenewalPay.val = true
      this.dialogRenewalTitle = '续费支付'
      this.renewalLoading = false
    },
    //获取续费产品详情
    async getRenewalProDetail(productId, packageCode) {
      let that = this
      let pro = {}
      let pack = {}
      await this.$tools
          .asyncPost(this, this.$baseUrl.hrproductGet, {
            data: {
              id: productId,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              pro = res.data.data
              //组装产品
              if (pro.hr_packages != null) {
                pack = pro.hr_packages.find(item => item.package_code = packageCode)
                //组装套餐
                pack.num = 1
                pack.unit = '2'
                //计算折扣价
                if (pack.package_discount === '1.00' && pack.discount_start === '' && pack.discount_end === '') {
                  pack.isInDeadline = false
                } else {
                  pack.isInDeadline = pack.discount_start == '' ? true : that.isCurrentTimeInDateRange(pack.discount_start, pack.discount_end)
                  let tmpPrice = pack.package_price * parseFloat(pack.package_discount)
                  if (tmpPrice < 0.01) {
                    pack.deadlinePrice = 0.01
                  } else {
                    pack.deadlinePrice = pack.package_price * parseFloat(pack.package_discount)
                  }
                }
                pack.total = pack.isInDeadline ? pack.deadlinePrice : pack.package_price
                //  单价单位  次还是月
                this.options5.forEach(item => {
                  if (pack.sales_type == item.dictionary_key) {
                    pack.singleUnit = item.dictionary_describe
                    pack.unit = pack.singleUnit == '次' ? '次' : '2'
                  }
                })

              } else {
                pro.hr_packages = []
              }
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      return {'pro': pro, 'pack': pack}
    },
    //续费订单支付
    onRenewalSubmit(type) {
      if (type == 'pay') {
        this.dialogRenewalPay.val = true
        this.dialogRenewalTitle = '支付结果'
      } else {
        this.dialogRenewalPay.val = false
      }
    },
    //根据下单及支付状态设置弹窗宽度
    changeDialogWidth() {
      this.dialogRenewalWidth = '920px'
    },
    isCurrentTimeInDateRange(startDate, endDate) {
      // 获取当前时间
      const now = new Date();

      // 如果startDate是字符串，则转换为Date对象
      const start = typeof startDate === 'string' ? new Date(startDate) : startDate;

      // 如果endDate是字符串，则转换为Date对象
      const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

      // 检查当前时间是否在范围内（包含边界）
      return now >= start && now <= end;
    },
    //  sse连接前token有效性测试
    testToken() {
      const token = localStorage.getItem('token');
      let newDate = Math.floor(Date.now() / 1000);
      var tokentime = jwt_decode(token).exp
      if (tokentime > parseInt(newDate)) {
        return true
      } else {
        ElementUI.MessageBox
            .confirm("当前用户会话超时，请重新登录?", "提示", {
              confirmButtonText: "确定",
              type: "error"
            })
            .then(() => {
              localStorage.clear()
              router.push({
                path: "/login"
              })
              return false
            }).catch(() => {
        })
      }
    },

    // ============ 退单管理相关方法 ============
    // 获取退单列表
    getRefundList(page = 1) {
      // 防止page为null或非数字
      const currentPage = parseInt(page) || 1;
      this.refundLoading = true;
      this.refundCurrentPage = currentPage;
      const params = {
        data: {
          page: currentPage,
          limit: parseInt(this.refundPagesize) || 10,
          product_type: this.refundSearchDate.product_type || '',
          order_id: this.refundSearchDate.order_id || '',
          approval_status: this.refundSearchDate.approval_status || '',
          product_type2: ["CN400", "CT300"]
        }
      };
      if (this.refundSearchDate.dateRange && this.refundSearchDate.dateRange.length === 2) {
        params.data.start_time = this.refundSearchDate.dateRange[0];
        params.data.end_time = this.refundSearchDate.dateRange[1];
      }
      this.$tools
          .asyncPost(this, this.$baseUrl.refundList, params)
          .then((res) => {
            if (res.data.code == 0) {
              this.refundTableData = res.data.data.data || [];
              this.refundTotal = res.data.data.total || 0;
            } else {
              this.$message({ type: "error", message: res.data.msg });
            }
            this.refundLoading = false;
          })
          .catch(() => {
            this.refundLoading = false;
          });
    },
    // 重置退单搜索
    resetRefundSearch() {
      this.refundSearchDate = {
        dateRange: [],
        product_type: '',
        order_id: '',
        approval_status: '',
      };
      this.refundCurrentPage = 1;
      this.refundPagesize = 10;
      this.getRefundList(1);
    },
    // 退单分页
    handleRefundSizeChange(val) {
      this.refundPagesize = parseInt(val) || 10;
      this.refundCurrentPage = 1;
      this.getRefundList(1);
    },
    handleRefundCurrentChange(val) {
      this.refundCurrentPage = parseInt(val) || 1;
      this.getRefundList(this.refundCurrentPage);
    },
    // 打开退单详情
    openRefundDetail(row) {
      this.dialogDetail.val = true;
      this.detailOrderId = row.order_id;
      this.detailOrderData = row.hr_order || {};
      this.refundOrderDetail = row;
      this.detailType = 'refund';
      this.detailWidth = '800px';
    },
    // 取消退单
    cancelRefund(row) {
      this.$prompt('请输入取消退单备注', '取消退单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入备注信息',
      }).then(({ value }) => {
        this.$tools
            .asyncPost(this, this.$baseUrl.refundCancel, {
              data: {
                id: row.id,
                order_id: row.order_id,
                approval_comment: value || ''
              }
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({ type: "success", message: "取消退单成功!" });
                this.getRefundList(this.refundCurrentPage);
              } else {
                this.$message({ type: "error", message: res.data.msg });
              }
            })
            .catch((err) => {
            });
      }).catch(() => {
      });
    },
    // 打开退单审核
    openRefundAudit(row) {
      this.refundAuditRow = row;
      this.refundAuditForm = {
        approval_status: '2',
        approval_comment: ''
      };
      this.refundAuditDialogVisible = true;
    },
    // 关闭退单审核
    closeRefundAudit() {
      this.refundAuditRow = {};
      this.refundAuditForm = {
        approval_status: '2',
        approval_comment: ''
      };
      if (this.$refs.refundAuditFormModel) {
        this.$refs.refundAuditFormModel.clearValidate();
      }
    },
    // 提交退单审核
    submitRefundAudit() {
      this.$refs.refundAuditFormModel.validate((valid) => {
        if (valid) {
          this.$tools
              .asyncPost(this, this.$baseUrl.orderToExamine, {
                data: {
                  id: this.refundAuditRow.id,
                  order_id: this.refundAuditRow.order_id,
                  approval_status: this.refundAuditForm.approval_status,
                  approval_comment: this.refundAuditForm.approval_comment || '',
                  order_role: JSON.parse(localStorage.getItem('useritem')).acctype
                }
              })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({ type: "success", message: "审核成功!" });
                  this.refundAuditDialogVisible = false;
                  this.getRefundList(this.refundCurrentPage);
                } else {
                  this.$message({ type: "error", message: res.data.msg });
                }
              })
              .catch((err) => {
              });
        }
      });
    },
    // 删除退单
    deleteRefund(row) {
      this.deleteRefundRow = row;
      this.deleteRefundDialogVisible = true;
    },
    // 关闭删除退单弹窗
    closeDeleteRefund() {
      this.deleteRefundDialogVisible = false;
      this.deleteRefundRow = {};
      this.deleteRefundLoading = false;
    },
    // 确认删除退单
    confirmDeleteRefund() {
      this.deleteRefundLoading = true;
      this.$tools
          .asyncPost(this, this.$baseUrl.refundDel, {
            data: {
              ids: [this.deleteRefundRow.id],
            }
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({ type: "success", message: "删除成功!" });
              this.closeDeleteRefund();
              this.getRefundList(this.refundCurrentPage);
            } else {
              this.$message({ type: "error", message: res.data.msg });
              this.deleteRefundLoading = false;
            }
          })
          .catch((err) => {
            this.deleteRefundLoading = false;
          });
    },

    // ============ 测试退单功能（后续删除） ============
    testRefund(row) {
      this.$tools
          .asyncPost(this, this.$baseUrl.orderGet, {
            data: {
              id: row.id,
              order_role: row.order_role
            }
          }).then(res => {
        if (res.data.code == 0) {
          const orderData = res.data.data;
          if (orderData.return_status) {
      this.$tools
          .asyncPost(this, this.$baseUrl.refundAdd, {
            data: {
              refund_reason: "测试退单",
                    refund_amount: orderData.payment_amount || orderData.total_amount,
                    order_id: orderData.id,
                    order_number: orderData.order_number,
                    user_id: orderData.user_id,
              refund_method: "1",
                    product_type: orderData.product_type,
              approval_comment: "",
                    order_role: orderData.order_role
            }
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({ type: "success", message: "退单成功!" });
              this.getList();
              } else {
                this.$message({ type: "error", message: res.data.msg });
              }
            });
          } else {
            this.$message({ type: "error", message: "该订单不可退单!" });
          }
            } else {
              this.$message({ type: "error", message: res.data.msg });
            }
          });
    },

  },
};
</script>

<style lang="less" scoped src="./index.less"></style>

<style lang="less">
.order-detail-dialog {
  width: 800px !important;
  height: 600px;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-detail-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 14px 20px 10px;
}

.order-detail-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  height: 0;
  overflow: hidden;
  padding: 0 20px 16px;
  box-sizing: border-box;
}
</style>
